import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL

export default {
  //管理端-列表
  noticeList: (data) => apiAxios('post', baseURL + '/notice.list', data),
  //管理端-添加通知
  noticeStore: (data) => apiAxios('post', baseURL + '/notice.store', data),
  //管理端-人员查询
  getAccountInfo: (data) => apiAxios('post', baseURL + '/notice.getAccountInfo', data),
  //后台用户-获取未查看的通知
  unreadNotice: (data) => apiAxios('post', baseURL + '/notice.unreadNotice', data),
  //后台用户-标记已读
  readNotice: (data) => apiAxios('post', baseURL + '/notice.readNotice', data),
  //后台用户-查看通知列表
  adminNoticeList: (data) => apiAxios('post', baseURL + '/notice.adminNoticeList', data),
  //后台用户-批量删除通知 
  batchDelete: (data) => apiAxios('post', baseURL + '/notice.batchDelete', data),
  //管理端-SASS平台列表
  sassPlatformList: (data) => apiAxios('post', baseURL + '/config.notice.sassPlatformList', data),
  //管理端-SASS平台全部客户列表
  sassPlatformUsers: (data) => apiAxios('post', baseURL + '/config.notice.sassPlatformUsers', data),
  //管理端-删除通知
  deleteNotice: (data) => apiAxios('post', baseURL + '/config.notice.deleteNotice', data),
  //管理端-仅修改标题和内容
  updateContent: (data) => apiAxios('post', baseURL + '/config.notice.updateContent', data),

  // 绑定cw特殊加群
  bindFoundRelation: (data) => apiAxios('post', baseURL + '/chatWork.bindFoundRelation', data),
  // cw特殊加群详情
  relationDetail: (data) => apiAxios('post', baseURL + '/chatWork.relationDetail', data),
  // cw批量建群
  batchCreation: (data) => apiAxios('post', baseURL + '/chatWork.batchCreation', data),
  // 群发消息模版添加
  templateSave: (data) => apiAxios('post', baseURL + '/chatWork.templateSave', data),
  // chatwork发送列表
  templateList: (data) => apiAxios('post', baseURL + '/chatWork.templateList', data),
  // chatwork发送删除
  templateDelete: (data) => apiAxios('post', baseURL + '/chatWork.templateDelete', data),
  // chatwork人员列表
  personnelInquiry: (data) => apiAxios('post', baseURL + '/chatWork.personnelInquiry', data),
  // chatwork导出发送详情
  downloadSendDetail: (data) => apiAxios('post', baseURL + '/chatWork.downloadSendDetail', data),
  // 创建拉取计划
  createPullPlan: (data) => apiAxios('post', baseURL + '/chatWork.createPullPlan', data),
  // 获取计划状态(三种状态:计划不存在,计划进行中,计划已完成)
  getPlanDetail: (data) => apiAxios('post', baseURL + '/chatWork.getPlanDetail', data),
  //CW群信息抽取
  groupDataPull: (data) => apiAxios('post', baseURL + '/chatWork.groupDataPull', data),
  //指定cw客户详情
  clusterPreview: (data) => apiAxios('post', baseURL + '/chatWork.clusterPreview', data),

  // rc发送列表
  pushList: (data) => apiAxios('post', baseURL + '/config.RCMsgPush.pushList', data),
  // rc新增群发
  RCMsgPush: (data) => apiAxios('post', baseURL + '/config.RCMsgPush.push', data),
  // 拟发送客户列表查看
  pushUserList: (data) => apiAxios('post', baseURL + '/config.RCMsgPush.pushUserList', data),
  // 推送列表-单条日志查看
  pushLogList: (data) => apiAxios('post', baseURL + '/config.RCMsgPush.pushLogList', data),

  // Email消息群发发送列表
  EmailPushPushList: (data) => apiAxios('post', baseURL + '/config.EmailPush.pushList', data),
  // Email消息群发新增群发
  EmailPushPushUserList: (data) => apiAxios('post', baseURL + '/config.EmailPush.pushUserList', data),
  // 拟发送客户列表查看
  EmailPushPushLogList: (data) => apiAxios('post', baseURL + '/config.RCMsgPush.pushLogList', data),
  // 推送列表-客户查询
  EmailPusGetAccountInfo: (data) => apiAxios('post', baseURL + '/config.notice.getAccountInfo', data),
  // 推送列表-新增群发
  EmailPusPush: (data) => apiAxios('post', baseURL + '/config.EmailPush.push', data),

}